<template>
  <card>
    <list
      v-if="$store.state.user.sections['info_projects']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
    <h4 v-else>{{ "no_acccess" | setText("НЕТ ДОСТУПА") }}</h4>
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "role",
      fields: [
        {
          key: "title",
          col: "col-12",
          label: "Название",
          labelKey: "title",
          isMultiLang: true,
          type: "field",
        },
        {
          key: "code",
          col: "col-12",
          label: "CODE",
          labelKey: "code",

          type: "field",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_info_project",
      itemLink: "info_projects",
      setLink: "info_projects",
      columns: [
        {
          key: "title",
          title: "Название",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "code",
          title: "CODE",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        // {
        //   key: "sections",
        //   object: "name",
        //   title: "Экраны",
        //   disableLink: true,
        //   checkbox: false,
        //   control: false,
        //   align: "left",
        //   timer: false,
        //   detail: false,
        // },

        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
